/* eslint-disable @typescript-eslint/no-non-null-assertion */
import * as THREE from 'three'
import { logoShieldBtImageUrl } from '../../assets'
import { ThreeComponet } from './types'
import vertexShader from './glsl/shieldObject.vs'
import fragmentShader from './glsl/shieldObject.fs'

interface ShieldObjectUniforms {
  time: THREE.IUniform<number>
  uFrequency: THREE.IUniform<THREE.Vector2>
  uTexture: THREE.IUniform<THREE.Texture | null>
  [uniform: string]: THREE.IUniform<any>
}

export default class ShieldObject extends ThreeComponet<ShieldObjectUniforms> {
  constructor() {
    super({
      time: {
        // type: 'f',
        value: 0,
      },
      uFrequency: {
        // type: 'v2',
        value: new THREE.Vector2(10, 5),
      },
      uTexture: {
        // type: 't',
        value: null,
      },
    })
  }

  // loadTexture(callback?: () => void): void {
  //   const loader = new THREE.TextureLoader()
  //   loader.load(logoImg, (texture) => {
  //     texture.magFilter = THREE.NearestFilter
  //     texture.minFilter = THREE.NearestFilter
  //     this.uniforms.texture.value = texture
  //     this.obj = this.createObj()
  //     this.isLoaded = true
  //     if (callback) callback()
  //   })
  // }

  createObj(): THREE.Mesh {
    // const mesh = new THREE.Mesh(
    //   new THREE.PlaneGeometry(256, 64, 40, 10),
    //   // new THREE.MeshPhongMaterial({
    //   //   map: this.uniforms.texture as unknown as THREE.Texture,
    //   // })
    //   new THREE.RawShaderMaterial({
    //     uniforms: this.uniforms,
    //     vertexShader,
    //     fragmentShader,
    //     transparent: true,
    //     depthWrite: false,
    //   })
    // )
    // mesh.position.set(0, 250, -0.1)
    const textureLoader = new THREE.TextureLoader()
    // eslint-disable-next-line prefer-const
    const flagTexture = textureLoader.load(logoShieldBtImageUrl)
    this.uniforms.uTexture.value = flagTexture
    const material = new THREE.RawShaderMaterial({
      vertexShader,
      fragmentShader,
      uniforms: {
        // 波浪间隙
        uFrequency: { value: new THREE.Vector2(10, 5) },
        // 时间
        time: this.uniforms.time,
        uTexture: this.uniforms.uTexture,
      },
      transparent: true,
      // depthWrite: false,
    })
    const mesh = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(256, 256, 32, 32),
      material
    )
    mesh.scale.set(0.75, 0.75, 0.75)
    mesh.position.set(0, 150, 0)
    return mesh
  }

  render(time: number): void {
    this.uniforms.time.value += time
  }
}
